import { createStore } from 'vuex';

export default createStore({
  state: {
    isLoggedIn: false,
    userName: null,
    userRole: null,
    flashMessage: '',
    flashType: '',
    isFlashVisible: false,
    isSearchExpanded: true,
    approvalPendingCountRefreshVersion: 0,
    globalLoadingCount: 0
  },
  getters: {
    isGlobalLoading(state) {
      return state.globalLoadingCount > 0;
    }
  },
  mutations: {
    setLoggedIn(state, value) {
      state.isLoggedIn = value;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    setUserRole(state, role) {
      state.userRole = role;
    },
    showFlashMessage(state, { message, type }) {
      state.flashMessage = message;
      state.flashType = type; // 'success', 'danger', 'warning' など
      state.isFlashVisible = true;
    },
    hideFlashMessage(state) {
      state.isFlashVisible = false;
    },
    setSearchExpanded(state, value) {
      state.isSearchExpanded = value;
    },
    requestApprovalPendingCountRefresh(state) {
      state.approvalPendingCountRefreshVersion += 1;
    },
    startGlobalLoading(state) {
      state.globalLoadingCount += 1;
    },
    stopGlobalLoading(state) {
      state.globalLoadingCount = Math.max(0, state.globalLoadingCount - 1);
    },
    resetGlobalLoading(state) {
      state.globalLoadingCount = 0;
    }
  },
  actions: {
    setLoggedIn({ commit }, status) {
      commit('setLoggedIn', status);
    },
    setUserName({ commit }, name) {
      commit('setUserName', name);
    },
    setUserRole({ commit }, role) {
      commit('setUserRole', role);
    },
    setFlashMessage({ commit }, { message, type }) {
      commit('showFlashMessage', { message, type });
      setTimeout(() => {
        commit('hideFlashMessage');
      }, 3000); // 3秒後にメッセージを非表示にする
    },
    setSearchExpanded({ commit }, value) {
      commit('setSearchExpanded', value);
    },
    requestApprovalPendingCountRefresh({ commit }) {
      commit('requestApprovalPendingCountRefresh');
    },
    startGlobalLoading({ commit }) {
      commit('startGlobalLoading');
    },
    stopGlobalLoading({ commit }) {
      commit('stopGlobalLoading');
    },
    resetGlobalLoading({ commit }) {
      commit('resetGlobalLoading');
    }
  }
});
